import { createStore } from "vuex";
import axios from "axios";
import { useProviderOnboardingStore } from '@/store/providerOnboardingStore';

export default createStore({
  state: {
    user: null,
    token: null,
    permissions: [],
    advertisement: null
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
    setAdvertisement(state, advertisement) {
      state.advertisement = advertisement;
    },
    setUserData(state, payload) {
      state.userData = payload
    },

    clearUser(state) {
      state.user = null;
    },
    clearToken(state) {
      state.token = null;
      // Remove o token do cabeçalho do Axios
      delete axios.defaults.headers.common["Authorization"];
    },
  },
  actions: {
    async postLogin({ commit }, { email, password }) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_URL_API}/auth`,
          {
            email,
            password,
          }
        );

        /*const { user, token, advertisement } = response.data;
        const permissionIdentifiers = user.permissions.map(p => p.identifier);*/
        const { user, token } = response.data;

        commit('setUser', user);
        commit('setToken', token);
        //commit('setPermissions', permissionIdentifiers);
        //commit('setAdvertisement', advertisement);

        localStorage.setItem('userData', JSON.stringify(response.data));

        return response.data
      } catch (error) {
        throw error;
      }
    },
    initializeStore({ commit }) {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsedData = JSON.parse(userData);
        commit('setUser', parsedData.user);
        commit('setToken', parsedData.token);
        //commit('setAdvertisement', parsedData.advertisement);
        //const permissionIdentifiers = parsedData.user.permissions.map(p => p.identifier);
        //commit('setPermissions', permissionIdentifiers);
      }
    },
    logout({ commit }) {
      commit('clearUser');
      commit('clearToken');
      localStorage.removeItem('userData');
      useProviderOnboardingStore().reset();
    },

    async signInWithGoogle({ commit }, { credential, provider_type, service_address, latitude, longitude }) {
      try {
        const body = { credential };
        if (provider_type) body.provider_type = provider_type;
        if (service_address) body.service_address = service_address;
        if (latitude != null) body.latitude = latitude;
        if (longitude != null) body.longitude = longitude;
        const response = await axios.post(
          `${process.env.VUE_APP_URL_API}/auth/google`,
          body
        );

        const { user, token } = response.data;

        if (token && user) {
          commit('setUser', user);
          commit('setToken', token);

          localStorage.setItem('userData', JSON.stringify(response.data));
        } else {
          commit('clearUser');
          commit('clearToken');
          localStorage.removeItem('userData');
        }

        return response.data;
      } catch (error) {
        throw error;
      }
    },

  },
  getters: {
    getUser: (state) => state.user,
    getToken: (state) => state.token,
    getPermissions: (state) => state.permissions,
    getAdvertisement: (state) => state.advertisement,
  },
  modules: {},
});